import { AgAppConfigService } from '@ag/vc.ag-core/settings';
import { Injectable } from '@angular/core';
import { AppConfigurationClient } from '@azure/app-configuration';

export type FeatureConfig = {
  [key:string]:boolean;
}
@Injectable({ providedIn: 'root'})
export class FeatureFlagService {

  async featureOff(featureName: string) {
    // Read the value from the Azure app configuration
    //const conn = AppConfigService.settings.AzureConnectionString;
    const conn = "Endpoint=https://appconfig-d001.azconfig.io;Id=5+53-l9-s0:q5lUicl+sxuqpST4HdYA;Secret=qRTKx3WkeEOIol0ujWR6OLp2guSLk2ABS8LxxZphA4Q=";
    const client = new AppConfigurationClient(conn);
    try {
      const val = await client.getConfigurationSetting({ key: ".appconfig.featureflag/" + featureName , label: featureName });
      console.log(val.key);
      return !(JSON.parse(val.value) as FeatureConfig).enabled  ?? false;
    }
    catch (e){
      console.log(e);
      return true;
    }
  }

  async featureOn(featureName: string) {
    return ! await this.featureOff(featureName);
  }

  async isFeatureAvailable(featureName: string): Promise<boolean> {
    // commenting the call, time being and using the feature flag from config file
    //return ! await this.featureOff(featureName);
    const flag = await new Promise<boolean>((resolve, _reject) => {
      setTimeout(() => {
        resolve(Boolean(AgAppConfigService.settings[featureName]));
      }, 1000);
    });
    return flag;
  }
}
